import React, { ReactElement } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import Path from '@root/utils/Path';
import { Link, withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

type PropType = {
    headerButton?: ReactElement<any>,
} & InjectedIntlProps & RouteComponentProps;

class Subheader extends React.Component<PropType> {

    // TODO: get all crumbs
    private getBreadcrumbs () {
        const [ , ...others] = this.props.location.pathname.split('/');
        const { items } = others.reduce((prevState, breadcrumb) => {
            const actualPath = `${prevState.actualPath}/${breadcrumb}`;
            return {
                items: [...prevState.items, actualPath ],
                actualPath,
            };
        }, { items: [], actualPath: '' });
        const keys = items.map((item) => Object.keys(Path).find((key) => Path[key] === item));
        return keys;
    }

    private isMainMenu(breadcrumb: string | undefined) {
        return !!this.props.intl.messages[`menu.${breadcrumb}`];
    }

    private renderBreadcrumb(breadcrumbs: Array<(string | undefined)>, lastBreadcrumb: string | undefined, moduleName: string | undefined) {
        return (
            <ol className="breadcrumb">
                {lastBreadcrumb !== 'dashboard' && (
                    <li>
                        <Link to={Path.dashboard}>{this.props.intl.formatMessage({ id: 'module.dashboard.dashboard' })}</Link>
                    </li>
                )}

                {breadcrumbs.map((breadcrumb, index) => {
                    let id = '';
                    if (index === 0 && this.isMainMenu(breadcrumb)) {
                        id = `menu.${breadcrumb}`;
                    } else {
                        id = `module.${moduleName}.${breadcrumb}`;
                    }

                    const to = breadcrumb ? Path[breadcrumb] : Path.dashboard;
                    if (breadcrumb === lastBreadcrumb) {
                        return (
                            <li key={breadcrumb}>
                                {this.props.intl.formatMessage({ id })}
                            </li>
                        );
                    }
                    return (
                        <li key={breadcrumb}>
                            <Link to={to}>{this.props.intl.formatMessage({ id })}</Link>
                        </li>
                    );
                })}
            </ol>
        );
    }

    public render() {
        const breadcrumbs = this.getBreadcrumbs().filter((b) => !!b);
        const lastBreadcrumb = breadcrumbs[(breadcrumbs.length - 1)];
        const moduleName = this.isMainMenu(breadcrumbs[0]) ? breadcrumbs[1] : breadcrumbs[0];

        return (
            <div className="row wrapper border-bottom white-bg page-heading subheader">
                <div>
                    <button className="btn btn-primary" onClick={() => document.body.classList.toggle("mini-navbar")}>
                        <i className="fa fa-bars" />
                    </button>
                </div>
                <div style={{flexGrow: 1}} className="wrapper">
                    <h2>
                        <span className="subHeaderTitle">{this.props.intl.formatMessage({ id: `module.${moduleName}.${lastBreadcrumb}` })}</span>
                    </h2>
                    {this.renderBreadcrumb(breadcrumbs, lastBreadcrumb, moduleName)}
                </div>
                {this.props.headerButton && <div>{this.props.headerButton}</div>}
            </div>
        );
    }
}

export default withRouter(injectIntl(Subheader));



// WEBPACK FOOTER //
// ./src/components/Subheader.tsx